import PropTypes from 'prop-types'
import { useState } from 'react'
import { Modal, Button } from 'react-bootstrap'

import Opiniones from './calificacionProducto/Opiniones'
import styles from './InformacionVendedor.module.css'

const ID_PARTICULAR = 3
const CANTIDAD_DE_ESTRELLAS_PARA_CALIFICAR = 5

const InformacionVendedor = ({ reputacion, publicacion }) => {
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => reputacion !== 0 && setShow(true)

  const obtenerReputacionEnEstrellas = (reputacion) => {
    if (!reputacion || reputacion.length === 0) {
      return 0
    }
    const promedio = reputacion[0].promedioReputacion // ya viene 1-5
    return Math.round(promedio) // redondeamos a entero (1-5)
  }

  const obtenerReputacionPromedioEnEstrellas = (reputacion) => {
    let promedioReputacionEnEstrellas
    if (reputacion === 0) {
      return 'null'
    } else {
      promedioReputacionEnEstrellas = reputacion.map((e) => e.promedioReputacion)
    }
    return promedioReputacionEnEstrellas[0]
  }

  const obtenerReputacion = (reputacion) => {
    if (reputacion === 0) {
      return 'null'
    } else {
      return reputacion.map((e) => (
        <Opiniones
          key={e.idCalificacion}
          calificacion={e.calificacionAlVendedor}
          comentario={e.comentario}
        />
      ))
    }
  }

  return (
    <div className={styles.container}>
      <h2 className="titulo-detalle pt-2 text-center mr-3">Información del vendedor</h2>
      <div className={styles.info}>
        <p className="text-center">
          <b>Razón social:</b> {publicacion.razonSocial}
        </p>

        {publicacion.idPerfil === ID_PARTICULAR ? (
          <p>
            <i
              className="fa fa-user-circle-o icons-publicacion mr-3"
              aria-hidden="true"
            ></i>
            Particular
          </p>
        ) : (
          <p>
            <i
              className="fa fa-building-o icons-publicacion  mr-3"
              aria-hidden="true"
            ></i>
            Empresa
          </p>
        )}
        <p>Opera desde: {new Date(publicacion.fechaAlta).toLocaleDateString('es-AR')}</p>
        {publicacion.esTiendaOficial && <p>Tienda Oficial</p>}
        <span className={reputacion !== 0 ? styles.linkText : ''} onClick={handleShow}>
          Puntuación Vendedor
        </span>
        {reputacion === 0 ? (
          <p className={`f-size-13 italic text-ebm ${styles.text}`}>
            Este vendedor no tiene suficientes calificaciones
          </p>
        ) : (
          <div>
            {[...Array(CANTIDAD_DE_ESTRELLAS_PARA_CALIFICAR)].map((_, index) => (
              <i
                key={index}
                className={`fa fa-star ${
                  index < obtenerReputacionEnEstrellas(reputacion)
                    ? 'text-warning'
                    : 'text-secondary'
                }`}
              ></i>
            ))}
          </div>
        )}
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Opiniones del Vendedor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col">
              <p className="puntuacion text-center">
                Puntuación Promedio:
                {obtenerReputacionPromedioEnEstrellas(reputacion)}
                <i className="fa fa-star yellow-star ml-3" aria-hidden="true"></i>
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <p className="puntuacion text-center">Opiniones</p>
            </div>
            <div className="col-10 bordered ml-auto mr-auto">
              {obtenerReputacion(reputacion)}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

InformacionVendedor.propTypes = {
  reputacion: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(
      PropTypes.shape({
        idCalificacion: PropTypes.number,
        promedioReputacion: PropTypes.number,
        calificacionAlVendedor: PropTypes.number,
        comentario: PropTypes.string
      })
    )
  ]).isRequired,
  publicacion: PropTypes.shape({
    vendedorNombre: PropTypes.string,
    idPerfil: PropTypes.number,
    fechaAlta: PropTypes.string,
    esTiendaOficial: PropTypes.bool,
    razonSocial: PropTypes.string
  }).isRequired
}

export default InformacionVendedor
